var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.editTimezone
      ? _c("div", { staticClass: "alert alert-secondary" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("watches.timezone.info")) +
              "\n        "
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-light btn-sm font-weight-bold",
              attrs: { type: "button" },
              on: { click: _vm.handleShowEditor },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.selected) + "\n            "
              ),
              _c("i", { staticClass: "pl-2 fa fa-pencil btn-icon" }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.editTimezone
      ? _c(
          "div",
          { staticClass: "alert alert-warning d-flex flex-column" },
          [
            _c("div", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(_vm.$t("watches.timezone.warning"))),
            ]),
            _vm._v(" "),
            _c("TimezonePicker", {
              staticClass: "mb-2",
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-2 d-flex flex-row" },
              [
                _c(
                  "Button2",
                  {
                    staticClass: "btn-sm btn-brand",
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleConfirmTimezone($event)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-check",
                      attrs: {
                        "aria-hidden": "true",
                        "aria-title": _vm.$t("watches.timezone.confirm"),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Button2",
                  {
                    staticClass: "mx-2 btn-sm btn-danger",
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleCancelTimezone($event)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-close",
                      attrs: {
                        "aria-hidden": "true",
                        "aria-title": _vm.$t("watches.timezone.cancel"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }